var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('p',[_vm._v("Autoclases Pablo - Todos los derechos reservados copyright 2023")])])
}]

export { render, staticRenderFns }